// extracted by mini-css-extract-plugin
export default {"checkbox":"CheckBox_checkbox__RyNFj","isBlock":"CheckBox_isBlock__Jr-m7","disabled":"CheckBox_disabled__Zjbdt","invert":"CheckBox_invert__CSTvI"};